import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text, TextArea, UploadImageArea } from '@reveni-io/reveni-ui'

import { claimTypeValues } from '@/common/constants'

import ClaimTypeSelector from './ClaimTypeSelector/ClaimTypeSelector'
import { claimTypes } from './ClaimTypeSelector/constants'
import { isFormValid } from './helpers'
import * as Styles from './styles'

const OpenClaimModal = ({ show, onClose, loading, onOpenClaim, uploadImage }) => {
  const { t } = useTranslation()
  const [description, setDescription] = useState('')
  const [claimType, setClaimType] = useState(claimTypes[0].value)
  const [claimImages, setClaimImages] = useState([])

  useEffect(() => {
    if (!show) {
      setDescription('')
      setClaimType(claimTypes[0].value)
      setClaimImages([])
    }
  }, [show])

  const onSendClaim = () => {
    onOpenClaim({ message: description, type: claimType, images: claimImages })
  }

  const handleChangeClaimType = e => {
    setClaimType(e.target.value)
  }

  const onSelectImages = async images => {
    await images.forEach(async image => {
      const uploadedImage = await uploadImage(image)
      setClaimImages(claimImages => [...claimImages, uploadedImage])
    })
  }

  const onDeleteImage = imageId => {
    setClaimImages(claimImages => claimImages.filter(img => img.id !== imageId))
  }

  return (
    <Modal show={show} title={t('Abrir incidencia')} size="l" onClose={onClose}>
      <Styles.Container>
        <Alert type="info">
          {t(
            'Para que tu reclamación se tramite con éxito, asegúrate de que el paquete ya está en manos del transportista (recogido o entregado en un punto).'
          )}
        </Alert>
        <Text type="bodyMRegular">{t('Describe brevemente el motivo de la incidencia')}:</Text>
        <ClaimTypeSelector value={claimType} handleChange={handleChangeClaimType} />
        <TextArea placeholder={t('Descripción')} value={description} onChange={e => setDescription(e.target.value)} />
        {claimType === claimTypeValues.deliveredDamagedOrMissingItems && (
          <>
            <Text type="bodyMRegular">{t('Adjunta imágenes del paquete y la etiqueta del envío:')}:</Text>
            <UploadImageArea
              backgroundColorArea="white"
              images={claimImages}
              onSelectImages={images => onSelectImages(images)}
              onDeleteImage={imageId => onDeleteImage(imageId)}
            />
          </>
        )}
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={onSendClaim}
            defaultLabel={t('Enviar')}
            loading={loading}
            disabled={!isFormValid(claimType, description, claimImages) || loading}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default OpenClaimModal
